
export enum InstanceActivityColumn {
    ACTION = 'action',
    DATE = 'date'
  }
  
  export const instanceActivityColumns = Object.values(InstanceActivityColumn) as string[];